import React, {useEffect, useMemo, useState, useRef} from 'react'
import {dataAniversarioFields, mapDataAniversarioToTable} from "./data-aniversario-fields"
import {Paper} from "@mui/material"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"
import MotorDataAniversarioService from "../../../../../../../services/motor-data-aniversario-service"
import {useLocation} from "react-router-dom"

const DataAniversarioTable = ({
    setLoading,
    idCaracteristica,
    dataAniversarioPublicado,
    showDataAniversario,
    tableData,
    setTableData,
    clearTable,
    datasAniversarioProjetadas
}) => {

    const service = useMemo(() => new MotorDataAniversarioService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state

    const possuiProjecaoRef = useRef(
        datasAniversarioProjetadas !== null
    )

    possuiProjecaoRef.current =
        datasAniversarioProjetadas !== null

    useEffect(() => {
        if (datasAniversarioProjetadas === null) return

        const formatted = mapDataAniversarioToTable(
            datasAniversarioProjetadas
        )

        setTableData(formatted)
        setTableKey(Math.random() * 10)
    }, [datasAniversarioProjetadas, setTableData])

    useEffect(() => {
        if (!showDataAniversario) return
        if (!idCaracteristica) return

        const origem = navigationState?.origem

        if (origem === "ver") {
            loadDataAniversario()
        }
    }, [
        showDataAniversario,
        idCaracteristica,
        navigationState,
    ])

    useEffect(() => {
        if (navigationState?.origem !== "duplicar") return

        const dadosOrigem =
            navigationState?.Data?.DataAniversario ??
            navigationState?.Data?.DatasAniversario ??
            []

        const formatted =
            mapDataAniversarioToTable(dadosOrigem)

        dataAniversarioPublicado(false)

        setTableData(formatted)
        setTableKey(Math.random() * 10)
    }, [
        navigationState,
        setTableData,
        dataAniversarioPublicado,
    ])

    const aplicarDadosDoGet = dados => {
        if (possuiProjecaoRef.current) return

        const formatted = mapDataAniversarioToTable(dados)

        setTableData(prev => {
            if (possuiProjecaoRef.current) {
                return prev
            }

            return formatted
        })

        setTableKey(Math.random() * 10)
    }

    const loadDataAniversario = () => {
        setLoading(true)

        service.getDataAniversario(idCaracteristica)
            .then(response => {
                if (possuiProjecaoRef.current) return

                const {body} = response

                if (body && body.length > 0) {
                    dataAniversarioPublicado(true)
                    aplicarDadosDoGet(body)
                } else {
                    loadDataAniversarioTemporario()
                }
            })
            .catch(error => console.error("Erro getDataAniversario:", error))
            .finally(() => setLoading(false))
    }

    const loadDataAniversarioTemporario = () => {
        setLoading(true)

        service.getTemporarioDataAniversario(idCaracteristica)
            .then(response => {
                if (possuiProjecaoRef.current) return

                const bodyTemp = response?.body || response?.data

                if (!bodyTemp) {
                    console.warn(
                        "Nenhum dado temporário encontrado"
                    )
                    return
                }

                const aniversarios = Array.isArray(bodyTemp)
                    ? bodyTemp
                    : bodyTemp?.DatasAniversario || []


                aplicarDadosDoGet(aniversarios)
                
            })
            .catch(error => console.error("Erro getTemporarioDataAniversario:", error))
            .finally(() => setLoading(false))
    }

    return (
        <Paper sx={{mt: 2}}>
            <DynamicColumnTable
                key={tableKey}
                actionButtons={true}
                copyData={() => copyTable(tableData, dataAniversarioFields)}
                pasteData={async () => await pasteTableFromClipboard(dataAniversarioFields, setTableData)}
                clearTable={() => clearTable(setTableData)}
                fields={dataAniversarioFields}
                items={tableData}
                setItems={setTableData}
            />
        </Paper>
    )
}

DataAniversarioTable.propTypes = {
    setLoading: PropTypes.bool,
    idCaracteristica: PropTypes.number,
    dataAniversarioPublicado: PropTypes.func,
    showDataAniversario: PropTypes.bool,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
    datasAniversarioProjetadas: PropTypes.array
}

export default DataAniversarioTable